<template>
  <div class="specialColumn">
    <div class="flex f-between">
      <!-- 列表-->
      <div class="special-left">
        <div class="">
          <div
            class="boxs-r ma-t-30 height302 flex f-between pa-b-20 b-b-1-e3"
            v-for="(item, index) in dataList"
            :key="index"
          >
            <div v-if="item.Image" class="ma-r-20">
              <img
                :src="item.Image"
                class="img_263 c-p"
                @click="toDetail(item.Id)"
              />
            </div>

            <div
              class="flex flex-direction flex-grow-1 pa-t-10 pa-r-20 f-between"
            >
              <div>
                <div
                  class="t-omit-2 fon-16 bold c-p"
                  @click="toDetail(item.Id)"
                >
                  {{ item.Name }}
                </div>
                <div
                  class="ma-t-20 fon-15 c-8a t-omit-4 c-p t-justify"
                  @click="toDetail(item.Id)"
                >
                  {{ item.Summary }}
                </div>
              </div>
              <div class="c-8a flex f-between fon-14 ma-t-10">
                <div>{{ item.ReleaseTime }}</div>
                <div class="flex f-center p-r">
                  <div>
                    <i class="iconfont icon-yanjing"></i>
                    {{ item.ViewCount }}
                  </div>
                  <div>
                  </div>
                  <div
                    class="box-share"
                    :id="'box-share-' + item.Id"
                    @mouseenter="shareMouseenter(item.Id)"
                    @mouseleave="shareMouseleave(item.Id)"
                  >
                    <div class="flex f-center">
                      <div class="t-center">
                        <img
                          v-if="qrUrls[index]"
                          :src="qrUrls[index]"
                          alt=""
                          srcset=""
                          width="120"
                          class="img-qrCode"
                        />
                        <div class="t-center">微信扫码分享</div>
                      </div>
                      <div class="p-r">
                        <img
                          src="../../img/weibo.png"
                          alt=""
                          srcset=""
                          width="60"
                          class="c-p ma-l-10"
                          title="点击分享"
                          @click="weibo(item)"
                        />
                      </div>
                      <div class="p-r ma-l-20">
                        <img
                          src="../../img/qzone.png"
                          alt=""
                          srcset=""
                          width="60"
                          class="c-p"
                          title="点击分享"
                          @click="QQShare(item)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="dataList.length == 0" class="width100 pa-t-100">
          <Empty></Empty>
        </div>

        <div class="fy">
          <el-pagination
            @current-change="handleCurrentChange"
            :hide-on-single-page="true"
            :current-page.sync="pageIndex"
            :page-size="pageSize"
            layout="prev, pager, next, jumper"
            :total="totals"
          >
          </el-pagination>
        </div>
      </div>
      <div class="special-right">
        <div class="flex">
          <img src="../../img/qrcode.png" alt="" class="width50 b-e3" />
          <div class="flex flex-direction f-jcenter pa-l-10">
            <div>了解更多信息请关注官方微信</div>
            <div class="bold c-234775 t-center ma-t-20">【数智方舟】</div>
          </div>
        </div>
        <!-- 热门标签 -->
        <!-- <div class="pa-t-20">
                    <div class="bold b-b-1-e3 pa-b-10">热门标签</div>
                    <div class="flex f-between f-wrap ma-t-10">
                        <div class=" fon-16 tips2 flex f-center f-jcenter" v-for="(items, indx) in 8" :key="indx">
                            大数据
                        </div>
                    </div>
                </div> -->
        <!-- 推荐文章 -->
        <div class="pa-t-20">
          <div class="bold b-b-1-e3 pa-b-10">推荐文章</div>
          <div class="ma-t-10">
            <div
              class="ma-b-20 fon-16 flex f-center f-jcenter t-omit-1 c-p"
              v-for="(items, indx) in dataHotList"
              :key="indx"
              @click="toDetail(items.Id)"
            >
              {{items.Name}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.fy{
  margin-top: 20px;
  margin-bottom: 20px;
  justify-content: center;
  display: flex;
}
.p-r {
  position: relative;
}

.tips2 {
  background: #bfbfbf;
  height: 30px;
  border-radius: 10px;
  margin-bottom: 10px;
  min-width: 26%;
}

.special-left {
  width: 65%;

  .boxs-r {
    background: #ffffff;

    .img_263 {
      width: 230px;
      height: 149px;
      object-fit: cover;
    }

    .img_30 {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      position: absolute;
      top: 205px;
      left: 10px;
    }
  }
}

.special-right {
  width: 30%;
}

.box-share {
  position: absolute;
  top: -160px;
  width: 290px;
  right: 0;
  // border: 1px solid red;
  background: #fff;
  padding: 10px;
  box-shadow: 0 1px 4px 0 #bdbdbd;
  border-radius: 2px;
  display: none;
}

.img-qrcode {
  .frame-img {
    margin: 20px auto;
    border: 2px solid #e4e7ed;
    height: 200px;
    width: 200px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 99%;
    }
  }
}
</style>
<script>
var _this;
import { getExpertNews } from "../../api.js";

//二维码生成
import QRCode from "qrcode";
// studycollect
export default {
  name: "specialColumn",
  components: {},
  data() {
    return {
      activeName: "",
      pageIndex: 1,
      pageSize: 10,
      name: "",
      totals: 0, //一个分类下的总条数
      dataList: [],
      qrUrls: [],
      dataHotList:[],//热门文章
    };
  },

  created() {
    _this = this;
    this.getList();
    this.loadDataHotList()
  },
  beforeRouteEnter(to, from, next) {
    window.scroll(0, 0);
    next();
  },

  // 其他页面进来时更新初始数据
  activated() {},

  methods: {
    //获取推荐文章列表
    loadDataHotList() {
      let data = {
        pageIndex: 1,
        pageSize: 10,
        sortType: 2,
      };
      getExpertNews(data).then((res) => {
        this.dataHotList = res.data.Data.List;
      });
    },
    //根据关键字搜索
    loadDataSearch(name) {
      _this.name = name;
      _this.getList();
    },
    getList() {
      let data = {
        title: this.name,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        expertsId: 0,
      };
      getExpertNews(data).then((res) => {
        if (res.data.Code == 0) {
          this.dataList = res.data.Data.List;

          this.totals = res.data.Data.TotalCount;
          this.loadDataQrUrl();
        }
      });
    },

    toDetail(id = 1) {
      this.$router.push({
        path: "/specialDetail",
        query: { id: id },
      });
    },
    //微博分享
    weibo(item) {
      var query = {
        title: item.Name,
        url: "http://www.fz-ai.net/Study-detail?id=" + item.Id,
      };
      if (item.Image) {
        query.pic = item.Image;
      }
      let url =
        "http://service.weibo.com/share/share.php?" + this.buildUrlQuery(query);
      window.open(url);
    },
    //QQ空间分享
    QQShare(item) {
      var query = {
        title: item.Name,
        summary: item.Summary,
        url: "http://www.fz-ai.net/Study-detail?id=" + item.Id,
      };
      if (item.Image) {
        query.pics = item.Image;
      }
      let url =
        "http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?" +
        this.buildUrlQuery(query);
      window.open(url);
    },
    //拼接url
    buildUrlQuery(query) {
      var queryItems = [];
      for (var k in query) {
        queryItems.push(k + "=" + encodeURIComponent(query[k] || ""));
      }
      return queryItems.join("&");
    },
    //获取二维码图片url
    loadDataQrUrl() {
      var _this = this;
      for (let index = 0; index < this.dataList.length; index++) {
        QRCode.toDataURL(
          "http://m.fz-ai.net/pages/resource/detail?Id=" +
            this.dataList[index].Id,
          {},
          function (err, url) {
            if (err) throw err;
            _this.qrUrls[index] = url;
          }
        );
      }
    },
    //鼠标悬浮分享按钮
    shareMouseenter(id) {
      let dom = document.getElementById("box-share-" + id);
      dom.style.display = "block";
    },
    //鼠标移开分享按钮
    shareMouseleave(id) {
      let dom = document.getElementById("box-share-" + id);
      dom.style.display = "none";
    },
    login() {
      let token = localStorage.getItem("AccessToken") || "";
      if (!token) {
        this.$confirm("您还未登录请先登录?", "提示", {
          confirmButtonText: "去登录",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$router.push("/Login");
          })
          .catch(() => {
            return false;
          });
      } else {
        return true;
      }
    },

    //点击切换种类
    handleClick(tab) {
      console.log(tab);

      this.pageIndex = 1;
      this.sortType = 0;
      this.getList();
    },

    upload(e) {
      window.open(e, "_blank");
    },

    // 设置保存页码
    save() {
      let kinds = this.kinds;
      this.saves = kinds.map((item) => {
        return { id: item.Id, page: 1 };
      });
    },

    // 详情
    collect(id) {
      this.$router.push({
        path: "/Study-detail",
        query: { paths: "/Resource", name: "学习资源", id: id },
      });
    },

    // 当前页改变时触发
    handleCurrentChange(e) {
      this.pageIndex = e;
      this.getList();
    },
  },
};
</script>
